import { PlaylistValidatorDecryptStage } from '@streamLoader/PlaylistDecrypt/PlaylistValidators/PlaylistValidatorDecryptStage';
import { V1PostParseValidator } from '@streamLoader/PlaylistDecrypt/PlaylistValidators/V1Scheme/Validarots/V1PostParseValidator/V1PostParseValidator';

export const VALIDATORS_MAP: Record<string, PlaylistValidatorDecryptStage[]> = {
  v1: [new V1PostParseValidator()],
};

export const KEYS_MAP: Record<string, string> = process.env.HLS_KEYS!.split(';').reduce<Record<string, string>>((s, c) => {
  const [id, value] = c.split(':');
  s[id] = value;
  return s;
}, {});
